import React from "react";
import { withTranslation } from "react-i18next";
import { Modal, ModalBody } from "reactstrap";
import crossIcon from "assets/images/cross.svg";
import Text from "components/Text";

function ConfirmRemoveModal({ t, isOpen, toggle, onConfirm, description, title, confirmationText, btnText }) {
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            className={"modal-dialog-centered modal-width-660"}
            modalClassName="custom-modal"
        >
            <span className="close-btn" onClick={toggle}>
                <img src={crossIcon} alt="close" />
            </span>
            <ModalBody className="text-center">
                <Text size="25px" marginBottom="10px" weight="500" color="#111b45">
                    <span className="modal-title-25">
                        {title}
                    </span>
                </Text>
                <Text
                    size="16px"
                    marginBottom="40px"
                    weight="300"
                    color="#535b5f"
                >
                    {description}
                </Text>
                <Text
                    size="16px"
                    marginBottom="40px"
                    weight="300"
                    color="#535b5f"
                >
                    {confirmationText}
                </Text>
                <button
                    className="button button-round button-shadow mr-md-4 mb-3 w-sm-100"
                    title={t("Remove")}
                    onClick={onConfirm}
                >
                    {btnText}
                </button>
                <button
                    className="button button-round button-border button-dark btn-mobile-link"
                    onClick={toggle}
                    title={t("Cancel")}
                >
                    {t("Cancel")}
                </button>
            </ModalBody>
        </Modal>
    );
}

export default withTranslation()(ConfirmRemoveModal);
